import React, { Fragment, useState } from 'react';
import { useNavigate } from 'react-router';
import {
    Row, Card, Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap';
import { H4, LI, P, Image, UL, Btn } from '../../../AbstractElements';
import errorImg from '../../../assets/images/search-not-found.png';
import { useSelector, useDispatch } from 'react-redux';
import { handleDelete } from 'Component/DashboardQeza/Common/DeleteUtils';
import { deleteBranch } from 'Services/Features/Branch/Utils/branchUtils';
import { setFormData } from 'Services/Features/Branch/branchSlice';

const BranchContent = ({ setRefetch }) => {
    const [openAccordion, setOpenAccordion] = useState(null);
    const toggleAccordion = (id) => {
        if (openAccordion === id) {
            setOpenAccordion(null);
        } else {
            setOpenAccordion(id);
        }
    };
    const branches = useSelector((state) => state.branch.branches);
    const operationHoursState = useSelector((state) => state.branch.currentBranch.operation_hours);
    // const currentBranch = useSelector((state) => state.branch.currentBranch);
    const dispatch = useDispatch();
    const layoutColumns = 3;
    const history = useNavigate();

    const initializeOperationHours = (itemHours) => {
        const parsedHours = itemHours ? JSON.parse(itemHours) : {};

        // Merge dengan state default yang sudah ada
        return { ...operationHoursState, ...parsedHours };
    };


    const handleEdit = (item) => {
        console.log(item, 'handleEditItem');
        // Simpan data photos dan banner ke state terpisah
        dispatch(setFormData({ photosLink: item.photos, bannerLink: item.banner }));

        // Buat objek baru tanpa photos dan banner
        const { photos, banner, ...updatedItem } = item;

        dispatch(setFormData({
            ...updatedItem,
            operation_hours: initializeOperationHours(item.operation_hours),
        }));

        history(`${process.env.PUBLIC_URL}/clinics/branch/edit/${item.id}`);
    };

    const handleDetail = (item) => {
        dispatch(setFormData({ photosLink: item.photos, bannerLink: item.banner }));

        // Buat objek baru tanpa photos dan banner
        const { photos, banner, ...updatedItem } = item;

        dispatch(setFormData({
            ...updatedItem,
            operation_hours: initializeOperationHours(item.operation_hours),
        }));
        dispatch(setFormData({
            branch_id: item.id,
            branch_name: item.name,
        }));
        // console.log(item, 'item');
        history(`${process.env.PUBLIC_URL}/clinics/branch/detail/${item.id}`);
    }

    return (
        <Fragment>
            <div className="product-wrapper-grid">
                <Row className="gridRow">
                    {branches && branches.map((item) => {
                        return (
                            <div id="gridId" className={`${layoutColumns === 3 ? 'col-xl-3 col-lg-6 col-sm-6 xl-4' : 'col-xl-' + layoutColumns}`} key={item.id}>
                                <Card >
                                    <div className="product-box">
                                        <div className="product-img" style={{ height: 'auto', overflow: 'hidden' }}>
                                            <Image attrImage={{ className: 'img-fluid w-100', src: item.photos ? item.photos : errorImg, alt: `${item.name}`, style: { height: '100%', objectFit: 'cover' } }} />
                                            <div className="product-hover">
                                                <UL attrUL={{ className: 'simple-list' }}>
                                                    <LI title="Delete" onClick={() => handleDelete(dispatch, item.id, setRefetch, deleteBranch)}><Btn attrBtn={{ color: 'transprant', type: 'button', datatoggle: 'modal', datatarget: '#exampleModalCenter' }}><i className="icon-trash"></i></Btn> </LI>
                                                    <LI title="Edit" onClick= {() => handleEdit(item)}><Btn attrBtn={{ color: 'transprant', type: 'button' }}><i className="icon-pencil-alt"></i></Btn></LI>
                                                    <LI title="Pengaturan" onClick={() => handleDetail(item)}><Btn attrBtn={{ color: 'transprant', type: 'button' }}><i className="icon-settings"></i></Btn></LI>
                                                </UL>
                                            </div>
                                        </div>
                                        <div className="product-details">
                                            <H4>
                                                <span title={item.name} style={{ cursor: 'default', color: 'inherit', textTransform: 'none'  }}>
                                                    {item.name && item.name.length > 23 ? `${item.name.substring(0, 23)}...` : item.name}
                                                </span>
                                            </H4>

                                            <P><i className="icon-location-pin"></i>
                                                <span title={item.location} style={{ cursor: 'default' }}>
                                                    {item.location && item.location.length > 35 ? `${item.location.substring(0, 35)}...` : item.location}
                                                </span>
                                            </P>
                                            <P><i className="icon-mobile"></i> {item.phone}</P>
                                            <div>
                                                {item.operation_hours && (() => {
                                                    try {
                                                        const operationHours = JSON.parse(item.operation_hours);
                                                        return (
                                                            <Accordion open={openAccordion === item.id ? '1' : ''} toggle={() => toggleAccordion(item.id)}>
                                                                <AccordionItem>
                                                                    <AccordionHeader targetId="1">
                                                                        Jam Operasional
                                                                    </AccordionHeader>
                                                                    <AccordionBody accordionId="1">
                                                                        <div style={{ display: 'grid', gridTemplateColumns: 'auto auto', gap: '8px' }}>
                                                                            {Object.entries(operationHours).map(([day, hours], index) => (
                                                                                <div key={index} style={{ display: 'contents' }}>
                                                                                    <div style={{ textAlign: 'right', paddingRight: '8px' }}><strong>{day.charAt(0).toUpperCase() + day.slice(1, 3)}:</strong></div>
                                                                                    <div style={{ textAlign: 'left' }}>{hours}</div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </AccordionBody>
                                                                </AccordionItem>
                                                            </Accordion>
                                                        );
                                                    } catch (e) {
                                                        console.error('Invalid JSON in operation_hours', e);
                                                        return null;
                                                    }
                                                })()}
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        );
                    })}
                </Row>
            </div>
        </Fragment>
    );
};
export default BranchContent;